import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/pls.png'
import _imports_1 from '@/assets/images/pls@2x.png'
import _imports_2 from '@/assets/images/pls@3x.png'
import _imports_3 from '@/assets/images/success.png'
import _imports_4 from '@/assets/images/success@2x.png'
import _imports_5 from '@/assets/images/success@3x.png'
import _imports_6 from '@/assets/images/right.png'
import _imports_7 from '@/assets/images/right@2x.png'
import _imports_8 from '@/assets/images/right@3x.png'
import _imports_9 from '@/assets/images/medal.png'
import _imports_10 from '@/assets/images/medal@2x.png'
import _imports_11 from '@/assets/images/medal@3x.png'
import _imports_12 from '@/assets/images/stripe.png'
import _imports_13 from '@/assets/images/stripe@2x.png'
import _imports_14 from '@/assets/images/stripe@3x.png'
import _imports_15 from '@/assets/images/asset.png'
import _imports_16 from '@/assets/images/asset@2x.png'
import _imports_17 from '@/assets/images/asset@3x.png'
import _imports_18 from '@/assets/images/file.png'
import _imports_19 from '@/assets/images/file@2x.png'
import _imports_20 from '@/assets/images/file@3x.png'


const _hoisted_1 = _imports_1 + ' 2x, ' + _imports_2 + ' 3x'
const _hoisted_2 = _imports_4 + ' 2x, ' + _imports_5 + ' 3x'
const _hoisted_3 = _imports_7 + ' 2x, ' + _imports_8 + ' 3x'
const _hoisted_4 = _imports_7 + ' 2x, ' + _imports_8 + ' 3x'
const _hoisted_5 = _imports_10 + ' 2x, ' + _imports_11 + ' 3x'
const _hoisted_6 = _imports_13 + ' 2x, ' + _imports_14 + ' 3x'
const _hoisted_7 = _imports_16 + ' 2x, ' + _imports_17 + ' 3x'
const _hoisted_8 = _imports_19 + ' 2x, ' + _imports_20 + ' 3x'
const _hoisted_9 = { class: "pi" }
const _hoisted_10 = { class: "icons" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    showPro: false,
    btnText: '开始认证',
    class: "pi",
    prePathName: "other"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "btn-skip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.skipPI && _ctx.skipPI(...args)))
        }, "跳过"),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "wrap-bg" }, [
          _createElementVNode("div", { class: "top" }, [
            _createElementVNode("img", {
              class: "pls",
              src: _imports_0,
              srcset: _hoisted_1,
              alt: ""
            }),
            _createElementVNode("img", {
              class: "success",
              src: _imports_3,
              srcset: _hoisted_2,
              alt: ""
            })
          ]),
          _createElementVNode("div", { class: "condition-wrap" }, [
            _createElementVNode("div", { class: "condition" }, [
              _createElementVNode("div", { class: "left" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: _imports_6,
                    srcset: _hoisted_3,
                    alt: ""
                  }),
                  _createElementVNode("span", null, "拥有资产≥八百万港币")
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: _imports_6,
                    srcset: _hoisted_4,
                    alt: ""
                  }),
                  _createElementVNode("span", null, "或等值外币的投资组合")
                ])
              ]),
              _createElementVNode("div", { class: "right" }, [
                _createElementVNode("img", {
                  src: _imports_9,
                  srcset: _hoisted_5,
                  alt: ""
                })
              ])
            ]),
            _createElementVNode("img", {
              class: "stripe",
              src: _imports_12,
              srcset: _hoisted_6,
              alt: ""
            })
          ])
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "p-title" }, "尊享特权", -1)),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.privilegeList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name
            }, [
              _createElementVNode("img", {
                src: item.url,
                alt: ""
              }, null, 8, _hoisted_11),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)
            ]))
          }), 128))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "p-title" }, "如何认证专业投资者？", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "methods" }, [
          _createElementVNode("div", { class: "method-item1" }, [
            _createElementVNode("div", { class: "text" }, [
              _createTextVNode("在金马证券"),
              _createElementVNode("br"),
              _createTextVNode("拥有≥800万港币的投资组合")
            ]),
            _createElementVNode("img", {
              src: _imports_15,
              srcset: _hoisted_7,
              alt: ""
            })
          ]),
          _createElementVNode("div", { class: "method-item2" }, [
            _createElementVNode("div", { class: "text" }, [
              _createTextVNode(" 上传"),
              _createElementVNode("br"),
              _createTextVNode(" 拥有≥800万港币的资产证明 ")
            ]),
            _createElementVNode("img", {
              src: _imports_18,
              srcset: _hoisted_8,
              alt: ""
            })
          ])
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "content" }, [
          _createElementVNode("div", null, " 作为被香港证券及期货事务监察委员会 [证监会] 监管的持牌法团，金马证券有限公司 [金马证券] 需遵守《证券及期货条例》 （香港法例第 571 章) [证券及期货条例]、证监会所制定的规则及其他相关的法规。 "),
          _createTextVNode(" 就《证券及期货条例》第 103、174 和 175 条、《公司（清盘及杂项条文）条例》（香港法例第 32 章）（「清盘及杂项条文条例」）附表17、《证券及期货（成交单据、户口结单及收据）规则》（香港法例第 571Q 章）[成交单据、户口结单及收据规则] 及证券及期货事务监察委员会持牌人或注册人操守准则（「操守准则」），金马证券建议把客户依照《证券及期货条例》附表 1 第 1 部 [专业投资者] 定义第(a) 至(j) 段及/或《证券及期货（专业投资者）规则》（香港法例第 571D 章) [专业投资者条例] 第 3 条第(a) 至(d) 段归类为[专业投资者]。 ")
        ], -1))
      ])
    ]),
    _: 1
  }, 8, ["onHandleNext"]))
}